import { cn } from '@/utils/cn';
import { isMenuItemGroup } from '@/utils/navigation.utils';
import { NavigationItem } from './Desktop/NavigationItem';
import { NavigationItemGroup } from './Desktop/NavigationItemGroup';
import { NAVIGATION_DATA } from './navigationItems';

export type DesktopNavigationProps = {
  className?: string;
};

export const DesktopNavigation = ({ className }: DesktopNavigationProps) => (
  <nav className={cn('hidden flex-1 xl:flex', className)}>
    {NAVIGATION_DATA.map((item) => {
      if (isMenuItemGroup(item)) {
        return <NavigationItemGroup item={item} key={item.id} />;
      }

      return <NavigationItem item={item} key={item.id} />;
    })}
  </nav>
);
